import React from 'react';
import {
  HelpLink, Stack, Text, useTranslation,
} from '@piwikpro/ui-components';
import classNameBind from 'classnames/bind';
import styles from './AddAppsToMetasiteConfirmation.module.css';

const bindClasses = classNameBind.bind(styles);

const AddAppsToMetasiteConfirmation = () => {
  const { t }: { t: (key: string) => string } = useTranslation();

  return (
    <Stack vertical horizontalAlignment="middle">
      <Stack.Item fill>
        <Stack vertical spacing="narrow">
          <Stack.Item>
            <Text as="p">{t('administration:meta-sites.addAppsToMetaSiteConfirm.message-line-1')}</Text>
          </Stack.Item>
          <Stack.Item>
            <ul className={bindClasses('unordered-list')}>
              <li>
                <Text as="p">{t('administration:meta-sites.addAppsToMetaSiteConfirm.message-bullet-1')}</Text>
              </li>
              <li>
                <Text as="p">{t('administration:meta-sites.addAppsToMetaSiteConfirm.message-bullet-2')}</Text>
              </li>
            </ul>
          </Stack.Item>
          <Stack.Item>
            <Text as="p">{t('administration:meta-sites.addAppsToMetaSiteConfirm.message-question')}</Text>
          </Stack.Item>
        </Stack>
      </Stack.Item>
      <Stack.Item>
        <HelpLink href="https://help.piwik.pro/support/tag-manager/about-meta-setup/">
          About the meta setup in Tag Manager
        </HelpLink>
      </Stack.Item>
    </Stack>
  );
};

export { AddAppsToMetasiteConfirmation };
